export const REQUEST_TRY_ROOMVU_VIDEO = 'REQUEST_TRY_ROOMVU_VIDEO';
export const FAILURE_TRY_ROOMVU_VIDEO = 'FAILURE_TRY_ROOMVU_VIDEO';
export const SUCCESS_TRY_ROOMVU_VIDEO = 'SUCCESS_TRY_ROOMVU_VIDEO';
